export default function gtag(command: 'js', date: Date): void;
export default function gtag(command: 'config', target: string, configuration?: any): void;
export default function gtag(command: 'get', target: string, field: string, callback: (value: unknown) => void): void;
export default function gtag(command: 'set', field: string, value: any): void;
export default function gtag(command: 'event', name: string, value?: any): void;
export default function gtag() {
    // eslint-disable-next-line prefer-rest-params
    (window.dataLayer ??= []).push(arguments);
}
